<script lang="ts" setup>
import { Field, useField, ErrorMessage } from 'vee-validate';

const { value } = useField<string>('flightNumber');

const props = defineProps<{
  errors?: string | string[];
}>();

</script>

<template>
  <div class="col">
    <div
      class="field"
      :class="{
        changed: value,
        'is-invalid': errors,
      }"
    >
      <Field
        type="text"
        name="flightNumber"
        id="flightNumber"
        :class="{ 'is-invalid': errors }"
        maxlength="6"
        @input="value = $event.target.value.toUpperCase()"
      />
      <label for="flightNumber">Operating Flight Number</label>
      <div class="invalid-feedback">
        <ErrorMessage name="flightNumber" />
      </div>
    </div>
  </div>
</template>
